import { render, staticRenderFns } from "./DatosUnidades.vue?vue&type=template&id=116ccf3f&scoped=true"
import script from "./DatosUnidades.vue?vue&type=script&lang=js"
export * from "./DatosUnidades.vue?vue&type=script&lang=js"
import style0 from "./DatosUnidades.vue?vue&type=style&index=0&id=116ccf3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ccf3f",
  null
  
)

export default component.exports